var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 10.001 16.001A8 8 0 008 0zm0 14.643A6.644 6.644 0 018 1.357a6.644 6.644 0 010 13.286z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.143 4.857a.857.857 0 101.714 0 .857.857 0 00-1.714 0zm1.285 2h-.857A.143.143 0 007.428 7v4.857c0 .079.065.143.143.143h.857a.143.143 0 00.143-.143V7a.143.143 0 00-.143-.143z"
  })));
}
export default SvgInfoIcon;